import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { OriginNumberArea } from "./Styles";

export default function Origin({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Origen"
            value={!value ? document.documents.origin.number : value}
          />
        </div>
      ) : (
        <OriginNumberArea>
          <Informative
            readonly={true}
            label="Origen"
            value={!value ? document.documents.origin.number : value}
          />
        </OriginNumberArea>
      )}
    </>
  );
}
